import React, { useEffect, useState } from "react";
import FormCustom from "../../components/FormCustom";
import TableCustom from "../../components/TableCustom";
import { getData } from "../../Tools/helpers";

const ModalUsers = ({selectedFranchise, setShowModalUsers, universityID}) =>{
  const [dataTable, setDataTable] = useState([]);
  const [dataForm, setDataForm] = useState({});
  const [isTrueUpdateData, setIsTrueUpdateData] = useState(false);
  const [isTrueDeleteData, setIsTrueDeleteData] = useState(false);

  const FieldsCustom = [
    { name: "name", label: "Nombre completo", required: "true" },
    { name: "email", label: "Email", required: "true" },
    { name: "password", label: "Contraseña", required: "true", type: "password" },
  ];

  const FieldsCustomTable = [
    { name: "name", label: "Nombre completo", required: "true" },
    { name: "email", label: "Email", required: "true" },
  ];

  const routeForm = "Franchise-User";

  const getUsersFranchises = async () => {
    const route = `${routeForm}/${universityID}`;
    const send = await getData(route);
    if (send.code === 200) {
      setDataTable(send.data);
    }
  };

  useEffect(()=>{
    setDataForm({
      ...dataForm,
      university_id: universityID
    });
    getUsersFranchises();
  },[])

    return(
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-bold">
              {`USUARIOS FRANQUICIA - ${selectedFranchise.name}`}
            </h3>
            <button 
              onClick={() => setShowModalUsers(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
          <div className="flex flex-1 flex-col border-b mb-4">
            <div className="flex-1 mb-10 max-w-2xl">
              <FormCustom
                fields={FieldsCustom}
                title=""
                route={routeForm}
                method="post"
                setData={setDataForm}
                data={dataForm}
                fieldDialog="name"
                setIsTrueUpdateData={setIsTrueUpdateData}
                isTrueUpdateData={isTrueUpdateData}
                refreshDataList={getUsersFranchises}
                setIsTrueDeleteData={setIsTrueDeleteData}
                isTrueDeleteData={isTrueDeleteData}
              />
            </div>
            <div className="flex-1">
              <TableCustom
                fields={FieldsCustomTable}
                setDataForm={setDataForm}
                data={dataTable}
                setIsTrueUpdateData={setIsTrueUpdateData}
                setIsTrueDeleteData={setIsTrueDeleteData}
              />
            </div>
          </div>
          <div className="mt-6 flex justify-between items-center">
            <div>
            </div>
            <div className="flex space-x-3">
              <button
                onClick={() => setShowModalUsers(false)}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    )
}

export default ModalUsers